import { PartialTranslation } from '../translations';

export const ko: PartialTranslation = {
  newChat: '새 채팅',
  search: '검색',
  user: '사용자',
  settings: '설정',
  language: '언어',
  getHelp: '도움말',
  viewAllPlans: '모든 플랜 보기',
  learnMore: '자세히 알아보기',
  logOut: '로그아웃',
  chooseLanguage: '언어 선택',
  chooseYourPreferredLanguage: '원하는 언어를 선택하세요',
  searchLanguages: '언어 검색...',
  autoDetect: '자동 감지',
  noLanguagesFound: '언어를 찾을 수 없습니다',
  askAnything: '무엇이든 물어보세요',
  lawhelperAi: 'Lawhelper.ai',
  personal: '개인',
  freePlan: '무료 플랜',
  current: '현재',
  close: '닫기',
  archive: '보관',
  delete: '삭제',
  confirmDelete: '이 채팅을 삭제하시겠습니까?',
  confirmArchive: '이 채팅을 보관하시겠습니까?',
  deleteCannotUndo: '이 작업은 되돌릴 수 없습니다.',
  archiveCanFind: '보관 후 보관 목록에서 찾을 수 있습니다.',
  // 资源面板
  resources: '리소스',
  addResource: '리소스 추가',
  deleteResource: '리소스 삭제',
  noMatchingResourcesFound: '일치하는 리소스를 찾을 수 없습니다',
  noResourcesAvailable: '사용 가능한 리소스가 없습니다',
  hideResources: '리소스 숨기기',
  showResources: '리소스 표시',
  
  // 聊天输入框
  typeMessage: '메시지 입력...',
  thinkingOptions: '사고 옵션',
  deleteFile: '파일 삭제',
  clearSelection: '선택 취소',
  
  // 思考模式选项
  deepInsight: '깊은 통찰 · 표면 분석',
  deepInsightDesc: '핵심 포인트의 빠른 이해',
  deepExploration: '깊은 탐색 · 포괄적 분석',
  deepExplorationDesc: '다차원적 심층 연구',
  deepDeconstruction: '깊은 해체 · 체계적 논증',
  deepDeconstructionDesc: '단계별 점진적 분석',
  
  // 写作模式选项
  contractReview: '계약 검토 · 위험 식별',
  contractReviewDesc: '조항 분석 및 규정 준수 확인',
  textPolish: '텍스트 다듬기 · 전문적 표현',
  textPolishDesc: '언어 최적화 및 구조 조정',
  legalDocuments: '법률 문서 · 표준 초안',
  legalDocumentsDesc: '전문 법률 문서 작성',
  addAttachment: '첨부 파일 추가',
  sendMessage: '메시지 보내기',

  // 认证和隐私翻译
  login: '로그인',
  register: '회원가입',
  welcomeBack: 'LawHelper에 오신 것을 환영합니다',
  loginSubtitle: 'AI 법률 연구 어시스턴트',
  continueWithGoogle: 'Google로 계속',
  continueWithMicrosoft: 'Microsoft로 계속',
  continueWithWeChat: 'WeChat으로 계속',
  orContinueWith: '또는 계속하기',
  emailTab: '이메일',
  phoneTab: '전화',
  emailPlaceholder: '이메일 입력',
  phonePlaceholder: '전화번호 입력',
  codePlaceholder: '6자리 코드 입력',
  sending: '전송 중...',
  verifying: '확인 중...',
  verify: '확인',
  sendMagicLink: '매직 링크 보내기',
  getVerificationCode: '코드 받기',
  resendCode: '코드 재전송',
  resendIn: '재전송까지',
  magicLinkSent: '매직 링크가 이메일로 전송되었습니다',
  magicLinkHint: '보안 링크를 이메일로 보내드립니다',
  otpSent: '인증 코드가 전송되었습니다',
  agreeToTerms: '계속하면 다음에 동의하게 됩니다',
  privacyPolicy: '개인정보 처리방침',
  termsOfService: '서비스 약관',
  and: '및',
  privacyTitle: '개인정보 보호가 중요합니다',
  privacyIntro: '최상의 경험을 제공하기 위해 쿠키 및 유사한 기술을 사용합니다.',
  essentialCookies: '필수 쿠키',
  essentialDesc: '웹사이트 기능에 필요',
  analyticsCookies: '분석 쿠키',
  analyticsDesc: '서비스 개선에 도움',
  marketingCookies: '마케팅 쿠키',
  marketingDesc: '맞춤형 콘텐츠에 사용',
  acceptAll: '모두 수락',
  essentialOnly: '필수만',
  customize: '사용자 정의',
  savePreferences: '설정 저장',
  back: '뒤로',
  readPrivacyPolicy: '개인정보 처리방침 읽기',
  cookiePolicy: '쿠키 정책',
  gdprCompliance: 'GDPR',
  piplCompliance: '개인정보보호법',

  // AI工具面板
  aiReview: 'AI 검토',
  aiDraft: 'AI 작성',
  smartAssistant: '템플릿',

  // 知识库搜索
  enableKnowledgeSearch: '지식 검색 활성화',
  knowledgeSearchDesc: 'AI가 문서에서 우선 검색',
  clickToDisable: '비활성화',
  clickToEnable: '활성화',

  // Landing page translations
  tagline: 'AI 기반 법률 인텔리전스',
  heroTitle1: 'Legal AI',
  heroTitle2: '간편하게.',
  jurisdictionsLabel: '관할권',
  accuracyLabel: '정확도',
  fasterLabel: '빠름',
  availableLabel: '이용 가능',
  platformCapabilities: '플랫폼 기능',
  testimonialQuote: '"LawHelper는 법률 업무를 완전히 바꿨습니다."',
  testimonialAuthor: '법률 전문가',
  testimonialPosition: '대형 로펌 파트너',
  viewPricing: '가격 보기',
  footerPricing: '가격',
  footerPrivacy: '개인정보',
  footerTerms: '이용약관',
  footerContact: '문의',
  footerCopyright: '© 2024 LawHelper.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: '리소스 패널 닫기',
  uploading: '%{fileName} 업로드 중...',
  processing: '%{fileName} 처리 중...',
  uploadSuccess: '✓ %{fileName} 업로드 완료',
  uploadError: '✗ 업로드 실패: %{error}',
  quickAnswer: '빠른 답변',
  quickAnswerDesc: '간단한 질문에 빠르게 답변',
  cancelRequest: '취소',
  library: '라이브러리',
  filterAll: '전체',
  filterChat: '채팅',
  filterReview: '검토',
  filterDraft: '초안',
  filterTemplate: '템플릿',
  filterForm: '양식',
  thinking: '생각 중...',
  thinkingProcess: '사고 과정',
  analyzingLegalLogic: '법적 논리 분석 중...',
  lawhelperThinking: 'Lawhelper 생각 중...',
  serviceError: '서비스 오류',
  uploaded: '업로드됨',
  settingsGeneral: '일반',
  settingsNotifications: '알림',
  settingsAppearance: '외관',
  settingsProfile: '프로필',
  settingsResponseNotifications: '응답 알림',
  settingsResponseNotificationsDesc: 'AI 응답 완료 시 알림',
  settingsColorMode: '색상 모드',
  settingsLight: '라이트',
  settingsDark: '다크',
  settingsSystem: '시스템',
  about: '정보',
  reviewTitle: '문서 검토',
  exitReview: '검토 종료',
  uploadPrompt: 'PDF를 업로드하여 검토 시작',
  uploadButton: '파일 선택',
  startChatConfig: '"이 문서를 검토"라고 입력하여 시작',
  reviewPlaceholder: '메시지 또는 "이 문서를 검토"를 입력...',
  analyzing: '검토 중...',
  reviewComplete: '검토 완료',
  issuesFound: '%{count}개 문제 발견',
  draftTitle: '법률 문서 초안 작성',
  draftPlaceholder: '여기에 편집하거나 AI에게 생성 요청...',
  analyzingTemplate: '템플릿 파일 %{name} 분석 중...',
  templateAnalyzed: '✅ 템플릿 %{name} 분석 완료! 수정 방법을 알려주세요.',
  templateAnalysisPrompt: '템플릿의 핵심 조항 분석',
  parsingFailed: '⚠️ 파일 구문 분석 실패, 요구사항을 직접 기술할 수 있습니다.',
  generating: '생성 중...',
  generatedSuccess: '✅ 문서가 생성되었습니다! 편집기에서 확인하세요.',
  drafterWelcome: 'AI 문서 어시스턴트에 오신 것을 환영합니다',
  drafterYouCan: '다음을 할 수 있습니다:',
  drafterUploadTemplate: '템플릿을 업로드하여 AI 분석',
  drafterDescribeNeeds: '문서 요구사항 기술',
  drafterLetAiHelp: 'AI가 계약서, 합의서 등 초안 작성 지원',
  drafterExamples: '예시:',
  drafterExampleRental: '"임대 계약서를 작성해 주세요"',
  drafterExampleLabor: '"템플릿에 따라 근로 계약서 작성"',
  drafterInputPlaceholder: '문서 요구사항을 기술하세요...',
  drafterThinking: '생각 중...',
  drafterHistoryTitle: '기록',
  drafterNoHistory: '기록 없음',
  drafterNewChat: '새 채팅',
  drafterHistory: '기록',
  drafterRemoveAttachment: '첨부 제거',
  drafterLineHeight: '줄 간격',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Word (.docx)로 내보내기',
  drafterExportPdf: 'PDF로 내보내기',
  drafterSave: '문서 저장',
  drafterDownload: '문서 다운로드',
  drafterUndo: '실행 취소',
  drafterRedo: '다시 실행',
  drafterBold: '굵게',
  drafterItalic: '기울임',
  drafterStrike: '취소선',
  drafterUnderline: '밑줄',
  drafterHighlight: '형광펜',
  drafterLink: '링크 삽입',
  drafterAlignLeft: '왼쪽 정렬',
  drafterAlignCenter: '가운데 정렬',
  drafterAlignRight: '오른쪽 정렬',
  drafterAlignJustify: '양쪽 정렬',
  drafterList: '목록',
  drafterBulletList: '글머리 기호',
  drafterOrderedList: '번호 매기기',
  drafterTaskList: '작업 목록',
  drafterOpenResource: '리소스 패널 열기',
  drafterStopGeneration: '생성 중지',
  drafterAgentMode: 'Agent 모드 활성 | 클릭하여 일반 채팅으로 전환',
  drafterAgentModeOn: 'Agent 모드 활성 | 클릭하여 일반 채팅으로 전환',
  drafterAgentModeOff: '일반 채팅 모드 | 클릭하여 Agent 모드로 전환',
  drafterUploadAttachment: '첨부 파일 업로드',
  drafterExit: '나가기',
  drafterConfirm: '확인',
  drafterOpenLink: '링크 열기',
  drafterDeleteLink: '링크 삭제',
  drafterQuote: '인용',
  workflowTitle: 'AI 워크플로',
  workflowRunning: '실행 중...',
  workflowReady: '준비 완료',
  workflowCompleted: '완료',
  workflowStartFailed: '워크플로 시작 실패',
  workflowExecutionFailed: '워크플로 실행 실패',
  workflowInterrupted: '워크플로 중단',
  workflowProcessing: '처리 중...',
  workflowStepsCompleted: '단계 완료',
  workflowStepsTotal: '워크플로 완료 (%{count}단계)',
  acceptChanges: '변경 승인',
  rejectChanges: '변경 거부',
  changesAccepted: '변경 승인됨',
  changesRejected: '변경 거부됨',
  stopWorkflow: '중지',
  restartWorkflow: '재시작',
  startDrafting: '초안 작성 시작',
  interrupt: '중지',
  documentSubject: '문서 제목 *',
  documentType: '문서 유형',
  jurisdiction: '관할권',
  specialRequirements: '특별 요구사항 (선택)',
  clickStartDrafting: '"초안 작성 시작"을 클릭하여 워크플로 시작',
  docTypeContract: '계약서',
  docTypeAgreement: '합의서',
  docTypeNotice: '통지서',
  docTypeLetter: '서신',
  docTypePetition: '청원서',
  docTypeWill: '유언장',
  docTypePowerOfAttorney: '위임장',
  countryChina: '중국',
  countryUSA: '미국',
  countryGermany: '독일',
  countryJapan: '일본',
  countryFrance: '프랑스',
  countryUK: '영국',
  citationVerified: '검증됨',
  citationUnverified: '미검증',
  imageLoadFailed: '이미지 로드 실패',
  smartDocTitle: '스마트 문서 어시스턴트',
  smartDocChatTitle: 'AI 문서 어시스턴트',
  smartDocDropPrompt: 'PDF 파일을 여기에 드롭',
  smartDocSelectFile: '파일 선택',
  smartDocOr: '또는',
  smartDocWelcomeTitle: 'AI 문서 어시스턴트에 오신 것을 환영합니다',
  smartDocWelcomeYouCan: '다음을 할 수 있습니다:',
  smartDocUploadForAI: '템플릿을 업로드하여 AI 분석',
  smartDocDescribeDoc: '문서 요구사항 기술',
  smartDocLetAIDraft: 'AI가 계약서, 합의서 등 초안 작성 지원',
  smartDocExamples: '예시:',
  smartDocExampleRental: '"임대 계약서를 작성해 주세요"',
  smartDocExampleLabor: '"템플릿에 따라 근로 계약서 작성"',
  smartDocInputPlaceholder: '문서 요구사항을 기술하세요...',
  smartDocRemoveAttachment: '첨부 제거',
  smartDocOpenResources: '리소스 패널 열기',
  smartDocExit: '나가기',
  reviewStartFailed: '검토 워크플로 시작 실패',
  reviewFailed: '검토 실패',
  reviewFoundIssues: '검토 완료, %{count}개 문제 발견.',
  cannotReadStream: '응답 스트림을 읽을 수 없습니다',
  parseEventFailed: '워크플로 이벤트 구문 분석 실패',
  errorPrefix: '오류',
  unknownError: '알 수 없는 오류',
  file: '파일',
  loading: '로딩 중...',
  localFolders: '로컬 폴더',
  selectLocalFolder: '로컬 폴더 선택',
  reselectFolder: '폴더 변경',
  addToContext: '채팅에 추가',
  saveFile: '저장',
  renameFile: '이름 변경',
  fileSaved: '파일이 저장되었습니다',
  fileRenamed: '파일 이름이 %{name}(으)로 변경됨',
  browserNotSupported: '브라우저가 로컬 폴더 액세스를 지원하지 않습니다',
  noFolderSelected: '파일을 탐색하려면 로컬 폴더를 선택하세요',
  scanningFolder: '폴더 스캔 중...',
  selectFileToPreview: '미리보기할 파일을 선택하세요',
  aiAnalyze: 'AI 분석',
};
